function l(a) {
  const n = "[ \\t\\f]*", i = "[ \\t\\f]+", t = n + "[:=]" + n, s = i, r = "(" + t + "|" + s + ")", e = "([^\\\\:= \\t\\f\\n]|\\\\.)+", c = { end: r, relevance: 0, starts: { className: "string", end: /$/, relevance: 0, contains: [{ begin: "\\\\\\\\" }, { begin: "\\\\\\n" }] } };
  return { name: ".properties", disableAutodetect: !0, case_insensitive: !0, illegal: /\S/, contains: [a.COMMENT("^\\s*[!#]", "$"), { returnBegin: !0, variants: [{ begin: e + t }, { begin: e + s }], contains: [{ className: "attr", begin: e, endsParent: !0 }], starts: c }, { className: "attr", begin: e + n + "$" }] };
}
export {
  l as default
};
